// Scenes tab. The Flutter app ships this as a placeholder ("No Scenes
// Available"); the real dynamic scene/automation experience lives in Wall Mode.

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, AppBar, Toolbar, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function ScenesScreen() {
  const navigate = useNavigate();
  return (
    <Box>
      <AppBar position="static" elevation={2}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={() => navigate('/home')}>
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flex: 1, textAlign: 'center' }}>Scenes</Typography>
          <Box sx={{ width: 40 }} />
        </Toolbar>
      </AppBar>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8, gap: 2 }}>
        <Typography color="text.secondary" variant="h6">No Scenes Available</Typography>
        <Button variant="contained" onClick={() => navigate('/wall')}>
          Open Wall Mode
        </Button>
      </Box>
    </Box>
  );
}
